import {Component, Input} from "@angular/core";
import {IOccasions} from "../../../../../../../../../server/src/base/entities/occasion/IOccasions";

/**
 * Created by Benoit Valkenberg on 10-12-17.
 */
@Component({
    selector: 'occasions-list',
    styleUrls: ['./occasions-list.scss'],
    templateUrl: './occasions-list.html'
})
export class OccasionsListComponent {

    @Input() occasions:IOccasions;

}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-list/occasions-list.ts